<template>
  <section>
    <h3>
      <a href="#">
        <v-icon>how_to_reg</v-icon>Uniformes
      </a>
    </h3>
    <p>Veja onde obter o uniforme dos alunos.</p>
    <p>
      <a href="/institucional/uniformes">
        <img src="/images/banana-bacana-uniformes-mapa.jpg" alt="mapa" style="width:100%">
      </a>
    </p>
    <p style="text-align:right !important;">
      <v-btn href="/institucional/uniformes" small depressed outline round color="primary">ver mais</v-btn>
    </p>
  </section>
</template>

<script>
export default {
  data: () => ({})
};
</script>

<style lang="scss" scoped>
p,
h2,
ul li,
ol li {
  text-align: left !important;
}
</style>



